import { ValidationCodes } from '../enums/ValidationCodes';
import { ValidateNHSCodeModule } from './validation-modules/ValidateNHSCodeModule';
import { ValidationModuleRegistry } from './ValidationModuleRegistry';

const validationRegister = new ValidationModuleRegistry();
validationRegister.registerValidationModule(ValidationCodes.NHS, ValidateNHSCodeModule);

export default validationRegister;
